// @flow

import type {Customer} from 'redux/v1/customer/data/models';
import type {Traveler} from 'redux/v1/travelers/data/models';
import type {TravelerForm} from 'redux/v1/travelers/form/models';
import type {Error} from 'redux/v1/travelers/put/models';

// import {toUpper} from 'lodash';
import {emptyForm} from 'redux/v1/travelers/form/models';

// import {config} from 'config';
import {formatISOtoDateString} from 'utils';

export const isTravelerNotEmpty = (traveler: Traveler): boolean => {
  return !!(
    (
      traveler.title &&
      traveler.firstName &&
      traveler.lastName &&
      traveler.birthday
    )
    // @todo add nationality to return in if FBO-3323 is done
    // && traveler.nationality
  );
};

export const mapTravelers = (travelers: Traveler[]): TravelerForm[] => {
  return travelers.map((traveler) => {
    return {
      data: {...traveler, birthday: formatISOtoDateString(traveler.birthday)},
      isValid: isTravelerNotEmpty(traveler),
    };
  });
};

export const createTravelerForms = (
  count: number,
  customer?: TravelerForm,
  customerAsTraveler?: number
): TravelerForm[] => {
  // @todo comment nationality in if FBO-3323 is done
  // const defaultNationality = toUpper(config.tld);

  return new Array(count)
    .fill(emptyForm)
    .map((trv: TravelerForm, index: number) => {
      if (index === customerAsTraveler && customer !== undefined) {
        return {
          ...customer,
          data: {
            ...customer.data,
            id: index + 1,
            // nationality: customer.data.nationality || defaultNationality,
          },
        };
      }

      return {
        ...trv,
        data: {
          ...trv.data,
          id: index + 1,
          // nationality: trv.data.nationality || defaultNationality,
        },
      };
    });
};

// represent parsed error object
export type ParsedErrors = {
  [travelerIdx: number]: {[fieldName: string]: string},
};

export const parseTravelerErrors = (errors: Error[] = []): ParsedErrors => {
  if (!Array.isArray(errors)) {
    errors = [];
  }

  return errors.reduce((accumulator, currentValue) => {
    if (!currentValue || !currentValue.relate || !currentValue.message) {
      return accumulator;
    }

    const idMatch = currentValue.relate.match(/\[(\d+)\]/);
    const id = idMatch && idMatch[1] ? Number.parseInt(idMatch[1], 10) : null;

    const fieldMatch = currentValue.relate.match(/\.([a-z]+)$/i);
    const fieldKey = fieldMatch && fieldMatch[1] ? fieldMatch[1] : null;

    if (id !== null && fieldKey) {
      accumulator[id] = {
        ...accumulator[id],
        [fieldKey]: currentValue.message,
      };
    } else {
      // for handling cases where id or fieldKey couldn't be extracted
      console.warn(
        `Could not parse error relate string: ${currentValue.relate}`
      );
    }

    return accumulator;
  }, {});
};

export const mapCustomer = (customer: Customer): TravelerForm => {
  // @todo comment nationality in if FBO-3323 is done
  // const defaultNationality = toUpper(config.tld);

  return {
    data: {
      id: 1,
      title: customer.title,
      firstName: customer.firstName,
      lastName: customer.lastName,
      birthday: customer.birthday
        ? formatISOtoDateString(customer.birthday)
        : customer.birthday,
      // nationality: defaultNationality,
    },
    isValid: isTravelerNotEmpty({
      ...customer,
      id: 1,
      // nationality: defaultNationality,
    }),
  };
};
